import { type LocationGroup } from '@/models/account-management/LocationGroup';
import { createApiResource } from '../adminApi';
import { HttpError, getJwt } from '../common';

const BASE_URL = import.meta.env.VITE_API_URL;

export const locationGroupApi = {
    ...createApiResource<LocationGroup, string>('account-management/locationgroups'),
    list: async (brandId: string): Promise<LocationGroup[]> => {
        const response = await fetch(`${BASE_URL}/account-management/locationgroups?brandId=${brandId}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${getJwt()}`
            }
        });

        const contentType = response.headers.get('content-type') ?? '';
        const data = contentType.includes('json') ? await response.json().catch(() => null) : await response.text().catch(() => '');

        if (!response.ok) throw new HttpError(response.status, data);
        return await data;
    },
};
